// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footerStyles_wrapper__1xB3F"};